import React from 'react';
import { Modal, Form, Input, Radio, Checkbox } from 'antd';
import BaseComponent from 'components/BaseComponent';
import { MaterialModel } from '@/routes/Material/Util/index';
import { connect } from 'dva';
import { qryUserById } from '../service';
import './index.less';
import $$ from 'cmn-utils';
//消息提示
import config from '@/config';
import { Img } from '../../../components/Material';



const notice = config.notice;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

@connect(({ homePage, loading }) => ({
	homePage,
	submitting: loading.effects['homePage/updatePassword']
}))
@Form.create()
/** 账户设置 */
export default class UserEditModal extends BaseComponent {

	constructor() {
		super();
		this.state = {
			isChangePwd: false, //是否修改密码标识

			tempRows: [],	// 临时存放 所有选中的数据,可多个
			tempKeys: [],	// 临时存放 当前选中的keys(id)
			checkRows: [],  // 点击确认后 真正使用的值
			checkKeys: [],  //点击确认后 真正使用的keys(id)
			visible: false,
			picVisible: false,
			type: '1',
			changedUser: ''
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.visible === false) {
			this.setState({
				checkRows: []
			});
		}
	}

	checkPassword = (rule, value, callback) => {
		if (!value) {
			this.setState({
				help: window.language['homepage.navBarModal.checkPassword1'],
				visible: !!value
			});
			callback();
		} else if (value.length < 6) {
			callback(window.language['homepage.navBarModal.checkPassword2']);
		} else {
			callback();
		}
	};


	checkConfirm = (rule, value, callback) => {
		const { form } = this.props;
		if (value && value !== form.getFieldValue('password')) {
			callback(window.language['homepage.navBarModal.checkConfirm']);
		} else {
			callback();
		}
	};

	/** logo方法开始 */
	showChooseLogoModal = () => {
		this.setState({
			picVisible: true,
		});
	}

	onMaterialChecked = (e, ele, type, rows, keys) => {
		if (!ele) {
			return;
		}
		// 单击 重新渲染
		let rowsArr = [ele];
		let keysArr = [ele.id];
		if (type === '1') { // 列表模式
			rowsArr = rows;
			keysArr = keys;
		}
		this.setState({
			tempRows: rowsArr,
			tempKeys: keysArr,
		});
	}

	onClearChecked = () => {
		this.setState({
			tempRows: [],
			tempKeys: [],
		})
	}

	clickBlankAreaClear = (e) => {
		if (e) {
			e.stopPropagation();
			if (e.target.nodeName === "DIV") {
				this.onClearChecked()
			}
		}
	}

	onOk = () => {
		let rows = this.state.tempRows;
		let keys = this.state.tempKeys;
		this.setState({
			checkRows: rows,
			checkKeys: keys,
			picVisible: false,
		});
	}

	onCancel = () => {
		this.setState({
			picVisible: false,
		});
	}

	onChange = (e) => {
		this.setState({
			isChangePwd: e.target.checked
		});
	}

	render() {
		const { visible, hideModelHandler, showModelHandler, user } = this.props;
		const { getFieldDecorator } = this.props.form;
		// const { name, email, website } = this.props.record;
		let changedUser = this.state.changedUser;

		const formItemLayout = {
			labelCol: { span: 6 },
			wrapperCol: { span: 14 }
		};

		let src = "";
		if (user.logo === null) {
			src = "assets/images/grey.jpg";
		} else if (this.state.checkRows.length === 0) {
			src = `${user.logo}`;
		} else {
			src = `${this.state.checkRows[0].path}`;
		}

		//logo表单样式
		const logoItemLayout = {
			labelCol: { span: 6 },
			wrapperCol: { span: 18 },
		};

		const tailFormItemLayout = {
			wrapperCol: {
				xs: {
					span: 13,
					offset: 13
				},
				sm: {
					span: 13,
					offset: 13
				}
			}
		};

		const picProps = {
			title: window.language['homepage.navBarModal.picPropsTitle'],
			visible: this.state.picVisible,
			height: 400,
			type: this.state.type,
			defaultShow: "0",
			isSingle: true,
			isUpload: true,
			onOk: this.onOk,           // 对选中的值进行操作
			onCancel: this.onCancel,   // 关闭模态窗口
			checkRows: this.state.tempRows,  // 选中的值
			checkKeys: this.state.tempKeys,  // 选中的key(存放id)
			onMaterialChecked: this.onMaterialChecked,  // 选中图片
			onClearChecked: this.onClearChecked,    // 清除选中数据
			clickBlankAreaClear: this.clickBlankAreaClear,
		}

		this.handleSubmit = (e) => {
			e.preventDefault();
			const { form, dispatch } = this.props;
			form.validateFields({ force: true }, (err, values) => {
				if (!err) {
					if (this.state.checkRows != null) {
						if (this.state.checkRows.length != 0) {
							values.logo = this.state.checkRows[0].path
						}
					}
					let oldPassword = form.getFieldValue('oldPassword');
					let password = form.getFieldValue('password');
					let confirmPassword = form.getFieldValue('confirmPassword');
					if (oldPassword !== undefined && password !== undefined && confirmPassword !== undefined) {
						let forge = require('node-forge');
						//md5加密
						let md1 = forge.md.md5.create();
						let md2 = forge.md.md5.create();
						let md3 = forge.md.md5.create();
						md1.update(oldPassword);
						md2.update(password);
						md3.update(confirmPassword);
						let md5OldPassword = md1.digest().toHex();
						let md5Password = md2.digest().toHex();
						let md5ConfirmPassword = md3.digest().toHex();
						let param = values;
						param.oldPassword = md5OldPassword;
						param.password = md5Password;
						param.confirmPassword = md5ConfirmPassword;
						dispatch({
							type: 'homePage/updatePassword',
							payload: {
								...values
							},
							success: () => {
								this.props.hideModelHandler();
								notice.success(window.language['homepage.navBarModal.updateSuccess1']);
								this.interval = setInterval(() => {
									window.location.href = "/sign/login"
								}, 3000);
							}
						});
					} else {
						dispatch({
							type: 'homePage/updateTipStatusAndLogo',
							payload: {
								...values
							},
							success: () => {
								this.props.hideModelHandler();
								notice.success(window.language['homepage.navBarModal.updateSuccess2']);
								let user = $$.getStore("user");
								qryUserById(user).then(
									response => {
										if (response.code === "200") {
											this.setState({
												changedUser: response.root
											});
										} else {
										}
									}
								).catch()
							}
						});
					}
				}
			});
		};

		let oldPasswordRule = false;
		if (this.state.isChangePwd === true) {
			oldPasswordRule = true;
		}

		let passwordRule = false;
		if (this.state.isChangePwd === true) {
			passwordRule = true;
		}

		let confirmPasswordRule = false;
		if (this.state.isChangePwd === true) {
			confirmPasswordRule = true;
		}

		return (
			visible &&
			<Modal
				title={window.language['homepage.userSetting.title']}
				visible={visible}
				onCancel={hideModelHandler}
				onOk={this.handleSubmit}
				width={500}
				height={705}
			>
				<Form onSubmit={this.handleSubmit}>
					<FormItem>{getFieldDecorator('id', {
						initialValue: user.id || '',
					}
					)(<Input type="hidden" />)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.userName']}>
						{getFieldDecorator('username', {
							rules: [
								{
									required: true,
									message: window.language['homepage.userSetting.enterUserName']
								}
							],
							initialValue: user.username || '',
						})(<Input disabled />)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.modifyOption']}>
						{getFieldDecorator('select', {
						})(<Checkbox onChange={this.onChange}>{window.language['homepage.userSetting.updatePassword']}</Checkbox>)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.oldPassword']}>
						{getFieldDecorator('oldPassword', {
							rules: [
								{
									required: oldPasswordRule,
									message: window.language['homepage.userSetting.enterOldPassword']
								}
							]
						})(<Input type="password" disabled={this.state.isChangePwd ? false : true} />)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.password']}>
						{getFieldDecorator('password', {
							rules: [
								{
									validator: this.checkPassword
								},
								{
									required: passwordRule,
									message: window.language['homepage.userSetting.enterPassword']
								}
							]
						})(<Input type="password" placeholder={window.language['homepage.userSetting.password.tip']} disabled={this.state.isChangePwd ? false : true} />)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.confirmPassword']}>
						{getFieldDecorator('confirmPassword', {
							rules: [
								{
									required: confirmPasswordRule,
									message: window.language['homepage.userSetting.enterConfirmPassword']
								},
								{
									validator: this.checkConfirm
								}
							]
						})(<Input type="password" disabled={this.state.isChangePwd ? false : true} />)}
					</FormItem>
					<FormItem {...formItemLayout} label={window.language['homepage.userSetting.tipStatus']}>
						{getFieldDecorator('tipStatus', {
							initialValue: user.tipStatus || '1',
						})(
							<RadioGroup>
								<Radio value="0">{window.language['homepage.userSetting.tipStatus.open']}</Radio>
								<Radio value="1">{window.language['homepage.userSetting.tipStatus.close']}</Radio>
							</RadioGroup>
						)}
					</FormItem>
					<FormItem {...logoItemLayout} label={window.language['homepage.userSetting.logo']}>
						{getFieldDecorator('logo', {
							getValueFromEvent: this.normFile
						})(
							<div>
								<Img src={src} style={{ width: 266, height: 84, cursor: 'pointer' }} onClick={this.showChooseLogoModal} />
								<span className="modify_pic">{window.language['homepage.userSetting.logo.tip']}</span>
							</div>
						)}
					</FormItem>
				</Form>
				<MaterialModel {...picProps} />
			</Modal>
		);
	}
}




// WEBPACK FOOTER //
// ./src/routes/HomePage/components/navBarModal.js